import React from 'react'
import { render } from '@trileuco/triskel-react-ui'
import BalaenaProvider from 'modules/bookables/Provider.js'
import BalaenaAuthComponent from 'components/auth/BalaenaAuthComponent'
import TopBarProgress from 'react-topbar-progress-indicator'

import widgetModule from './module'
import BookingWidget from './BookingWidget'

const appThemeImport = (theme) => {
  if (theme === 'caribean') {
    TopBarProgress.config({
      barColors: {
        0: '#89be40',
        '1.0': '#89be40'
      },
      shadowBlur: 1
    })
  } else if (theme === 'balaena' || theme === 'balaenatravel') {
    TopBarProgress.config({
      barColors: {
        0: '#fcc736',
        '1.0': '#eaa902'
      },
      shadowBlur: 1
    })
  } else if (theme === 'forest') {
    TopBarProgress.config({
      barColors: {
        0: '#fcc736',
        '1.0': '#eaa902'
      },
      shadowBlur: 1
    })
  }
  if (theme) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackMode: "lazy" */ `styles/theme.${theme}.scss`)
  }
}

export const init = (config) => {
  const { tenant } = config
  appThemeImport(tenant.theme)
  render({
    rootId: 'root-widget',
    // eslint-disable-next-line react/display-name
    CustomProvider: (props) => (
      <BalaenaProvider {...props} tenantConfig={tenant} />
    ),
    // eslint-disable-next-line react/display-name
    RouterLayout: (props) => <BookingWidget {...props} {...config} />,
    notifications: {
      position: 'right',
      align: 'start'
    },
    ...tenant,
    authentication: {
      AuthComponent: BalaenaAuthComponent,
      ...tenant.authentication
    },
    modules: [widgetModule]
  })
}
